// extracted by mini-css-extract-plugin
export default {"Spin":"Spin_Spin__mhNs+","Right":"Spin_Right__CReDh"};